import { render, staticRenderFns } from "./ImportarSignatariosTabela.vue?vue&type=template&id=1ec85d8f"
import script from "./ImportarSignatariosTabela.vue?vue&type=script&lang=js"
export * from "./ImportarSignatariosTabela.vue?vue&type=script&lang=js"
import style0 from "./ImportarSignatariosTabela.vue?vue&type=style&index=0&id=1ec85d8f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports